import { render, staticRenderFns } from "./RegisterStepListItem.vue?vue&type=template&id=059c98c0&scoped=true&"
import script from "./RegisterStepListItem.vue?vue&type=script&lang=js&"
export * from "./RegisterStepListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStepListItem.vue?vue&type=style&index=0&id=059c98c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c98c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059c98c0')) {
      api.createRecord('059c98c0', component.options)
    } else {
      api.reload('059c98c0', component.options)
    }
    module.hot.accept("./RegisterStepListItem.vue?vue&type=template&id=059c98c0&scoped=true&", function () {
      api.rerender('059c98c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/register/components/steps/RegisterStepListItem.vue"
export default component.exports